import { pr, theme } from "aaa";
import * as React from "react";

const baseIconStyle = {
    display: "block",
    padding: 12,
    // paddingTop: 10,
};

// TODO also use in FIT
export const InfoBoxWithBackground = ({
    variant = "info",
    iconColor,
    children,
    className,
    iconSize = 24,
    borderColor,
    borderWidth,
    borderRadius,
    backgroundColor,
    opacity,
    style
}: {
    variant?: "info" | "warning" | "error",
    iconColor?: string,
    children: React.ReactNode,
    className?: string;
    iconSize?: number,
    borderColor?: string,
    borderWidth?: number,
    borderRadius?: number,
    backgroundColor?: string,
    opacity?: number,
    style?: React.CSSProperties
}) => {
    const getBorderColor = () => {
        if (borderColor) {
            return borderColor;
        }

        switch (variant) {
            case "error": return "rgba(231, 34, 34, 1)";
            case "warning": return "rgba(173, 87, 0, 0.2)";
            case "info":
            default: return "rgb(25, 156, 249)";
        }
    };

    const getBackgroundColor = () => {
        if (backgroundColor) {
            return backgroundColor;
        }

        switch (variant) {
            case "error": return "rgba(231, 34, 34, 0.2)";
            case "warning": return "rgba(255, 244, 213, 1)";
            case "info":
            default: return "rgba(25, 156, 249, 0.2)";
        }
    };

    const iconSizeStyle = iconSize ? {
        width: iconSize,
        height: iconSize,
    } : {};

    return (
        <div
            className={className}
            style={{
                display: "flex",
                alignItems: "flex-start",
                borderRadius: borderRadius ?? 4,
                border: `${borderWidth ?? 1}px solid ${getBorderColor()}`,
                backgroundColor: getBackgroundColor(),
                ...(opacity !== undefined && { opacity }),
                ...style
            }}
        >
            <div>
                {variant === "info" && <pr.IconInfoCircleHollow style={{ ...baseIconStyle, ...iconSizeStyle, color: iconColor ?? theme.themeColors.ui_blue }} />}
                {variant === "warning" && <pr.IconWarning style={{ ...baseIconStyle, ...iconSizeStyle, color: iconColor ?? theme.themeColors.ui_yellow }} />}
                {variant === "error" && <pr.IconWarning style={{ ...baseIconStyle, ...iconSizeStyle, color: iconColor ?? theme.themeColors.ui_red }} />}
            </div>
            <div style={{ padding: "10px 12px", paddingLeft: 0 }}>
                {children}
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/common/InfoBoxWithBackground.tsx